import { create } from 'apisauce';
import config from '../config';

const api = create({
  baseURL: config.API_URL,
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json'
  },
  timeout: 30000
});

class CmsApi {
  static getContent() {
    return api.get(`/cms`);
  }
}

export default CmsApi;



// WEBPACK FOOTER //
// ./src/api/cmsApi.js